import { useState } from 'react';
import { CODE_LENGTH, isValidCode } from '@numslearn/shared';
import { useSettings } from '../settings.js';
import { navigate } from '../router.js';

/** The front door: a code box for students, two quiet doors for everyone else. */
export function Home() {
  const { t } = useSettings();
  const [code, setCode] = useState('');
  const valid = isValidCode(code);

  return (
    <div className="home">
      <section className="home-hero">
        <h1>{t('app.name')}</h1>
        <p>{t('home.blurb')}</p>
      </section>

      <form
        className="home-card is-primary"
        onSubmit={(e) => { e.preventDefault(); if (valid) navigate(`/join/${code.toUpperCase()}`); }}
      >
        <h2>{t('home.joinTitle')}</h2>
        <p>{t('home.joinHint')}</p>
        <div className="code-row">
          <input
            className="code-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, CODE_LENGTH))}
            placeholder="ABC123"
            aria-label={t('home.code')}
            autoComplete="off"
            autoCapitalize="characters"
            spellCheck={false}
            inputMode="text"
          />
          <button className="gbtn pri" type="submit" disabled={!valid}>{t('home.go')}</button>
        </div>
      </form>

      <div className="home-row">
        <section className="home-card">
          <h2>{t('home.practiceTitle')}</h2>
          <p>{t('home.practiceHint')}</p>
          <button className="gbtn" onClick={() => navigate('/practice')}>{t('home.practiceGo')}</button>
        </section>
        <section className="home-card">
          <h2>{t('home.teacherTitle')}</h2>
          <p>{t('home.teacherHint')}</p>
          <button className="gbtn" onClick={() => navigate('/teacher')}>{t('home.teacherGo')}</button>
        </section>
      </div>
    </div>
  );
}
